module.exports = __webpack_public_path__ + "media/images/pharma_admin/icons/download-a4b7192f937fe82a7c8b1505148e97db.svg";